import React from 'react';
import styled from 'styled-components/macro';
import { SecondaryButton } from '../../../../../shared/Button';
import { fontWeightBold, fontWeightMedium } from '../../../../../styling/fonts';

export type RoomsHeatLossTableViewType = 'Roof' | 'Wall' | 'Floor';

type Props = {
  unitIndex: number;
  selectedViewType: RoomsHeatLossTableViewType;
  setViewType: (roomsHeatLossTableViewType: RoomsHeatLossTableViewType) => void;
};

export const RoomsHeatLossTableViewTypeButtons = ({ unitIndex, selectedViewType, setViewType }: Props) => {
  const options: Array<{ viewType: RoomsHeatLossTableViewType; displayText: string }> = [
    { viewType: 'Roof', displayText: 'Roof' },
    { viewType: 'Wall', displayText: 'Wall' },
    { viewType: 'Floor', displayText: 'Floor' },
  ];

  return (
    <>
      {options.map(option => (
        <RoomsHeatLossTableViewTypeButton
          key={option.viewType}
          unitIndex={unitIndex}
          viewType={option.viewType}
          setViewType={setViewType}
          selectedViewType={selectedViewType}
        >
          {option.displayText}
        </RoomsHeatLossTableViewTypeButton>
      ))}
    </>
  );
};

type RoomsHeatLossTableViewTypeButtonProps = {
  unitIndex: number;
  viewType: RoomsHeatLossTableViewType;
  selectedViewType: RoomsHeatLossTableViewType | null;
  setViewType: (roomsHeatLossTableViewType: RoomsHeatLossTableViewType) => void;
  children?: React.ReactNode;
};

const RoomsHeatLossTableViewTypeButton = ({
  unitIndex,
  viewType,
  selectedViewType,
  setViewType,
  children,
}: RoomsHeatLossTableViewTypeButtonProps) => (
  <ToggleButton
    onClick={() => setViewType(viewType)}
    $isCurrent={selectedViewType === viewType}
    data-testid={roomsHeatLossTableViewTypeToggleButtonTestId(unitIndex, viewType)}
  >
    {children}
  </ToggleButton>
);

const ToggleButton = styled(SecondaryButton)<{ $isCurrent: boolean }>`
  opacity: ${props => (props.$isCurrent ? 1 : 0.75)};
  font-weight: ${props => (props.$isCurrent ? fontWeightBold : fontWeightMedium)};

  &:hover,
  &:focus {
    opacity: 1;
  }
`;

export const roomsHeatLossTableViewTypeToggleButtonTestId = (unitIndex: number, viewType: RoomsHeatLossTableViewType) =>
  `unit-${unitIndex}-toggle-heat-loss-modal-room-view-${viewType}`;
